import { Vue } from "vue-ext";
Vue.mixin({
    components: {
        NumberInput: require("./NumberInput.vue").default,
        OptionList: require("./OptionList.vue").default,
        InfoDisplay: require("./InfoDisplay.vue").default,
        WorktopDrawing: require("./WorktopDrawing.vue").default,
        BackpanelDrawing: require("./BackpanelDrawing.vue").default,
        Instructions: require("./Instructions.vue").default,
        Popup: require("./Popup.vue").default,
        SinkSelectionPopup: require("./SinkSelectionPopup.vue").default,
        HobcutoutSelectionPopup: require("./HobcutoutSelectionPopup.vue").default,
        MiniCart: require("./MiniCart.vue").default,
    }
});
